type LocaleChangeHandler = (locale: string | undefined) => void;

const onLocaleChangeHandlers: LocaleChangeHandler[] = [];
export function onLocaleChange(handler: LocaleChangeHandler) {
  onLocaleChangeHandlers.push(handler);
}

export function emitLocaleChange(locale: string | undefined) {
  onLocaleChangeHandlers.forEach((handler) => handler(locale));
}

type TranslationLoadErrorHandler = (language: string, namespace: string, message: string) => void;

const onTranslationLoadErrorHandlers: TranslationLoadErrorHandler[] = [];

export function onTranslationLoadError(handler: TranslationLoadErrorHandler) {
  onTranslationLoadErrorHandlers.push(handler);
}

export function emitTranslationLoadError(language: string, namespace: string, message: string) {
  onTranslationLoadErrorHandlers.forEach((handler) => handler(language, namespace, message));
}

export const __TEST_ONLY_INTERNALS__ = {
  onLocaleChangeHandlers,
  onTranslationLoadErrorHandlers,
};
